<template>
  <div>
    <v-container>
      <v-dialog persistent v-model="dialog.create" max-width="590">
        <template v-slot:activator="{ on }">
          <div style="text-align: right; margin-bottom: 10px">
            <v-btn v-on="on" color="primary">สร้าง</v-btn>
          </div>
        </template>
        <v-card v-if="dialog.create">
          <v-card-text>
            <h5>สร้างโครงการ</h5>
            <div class="form-control" :class="{ 'has-error': errors.has('projectname') }">
              <label>ชื่อโครงการ</label>
              <input
                :data-vv-as="$t('projectname')"
                v-validate="'required'"
                name="projectname"
                v-model="input.projectname"
                type="text"
              />
              <span class="text-error" v-if="errors.has('projectname')">{{
                errors.first('projectname')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('description') }">
              <label>รายละเอียดโครงการ</label>
              <input
                :data-vv-as="$t('รายละเอียดโครงการ')"
                v-validate="'required'"
                name="description"
                v-model="input.description"
                type="text"
              />
              <span class="text-error" v-if="errors.has('description')">{{
                errors.first('description')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('phoneno') }">
              <label>เบอร์โทรศัพท์</label>
              <input
                :data-vv-as="$t('phone')"
                v-validate="'required'"
                name="phoneno"
                v-model="input.phoneno"
                type="number"
              />
              <span class="text-error" v-if="errors.has('description')">{{
                errors.first('description')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('goal') }">
              <label>ระยะทางที่ตั้งเป้าไว้</label>
              <input
                :data-vv-as="$t('goal')"
                v-validate="'required'"
                name="goal"
                v-model="input.goal"
                type="number"
              />
              <span class="text-error" v-if="errors.has('goal')">{{ errors.first('goal') }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('endproject') }">
              <label>วันสิ้นสุดโครงการ</label>
              <v-menu
                ref="appointmentStart"
                v-model="showEndproject"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template v-slot:activator="{ on }">
                  <div>
                    <input
                      type="text"
                      name="endproject"
                      v-validate="'required'"
                      :data-vv-as="$t('endproject')"
                      class="form-control browser-default"
                      :placeholder="$t('')"
                      readonly
                      :value="formattedEndprojectDate"
                      v-on="on"
                      clearable
                    />
                  </div>
                </template>
                <v-date-picker
                  v-model="input.endproject"
                  no-title
                  @input="showEndproject = false"
                ></v-date-picker>
              </v-menu>
              <span class="text-error" v-if="errors.has('endproject')">{{
                errors.first('endproject')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('address') }">
              <label>ที่อยู่</label>

              <autoresize-textarea
                :data-vv-as="$t('address')"
                name="address"
                v-validate="'required'"
                v-model="input.address"
              />
              <span class="text-error" v-if="errors.has('address')">{{
                errors.first('address')
              }}</span>
            </div>

            <v-layout row>
              <v-flex pa-1 xs6>
                <div class="form-control" :class="{ 'has-error': errors.has('latitude') }">
                  <label>latitude</label>
                  <input
                    :data-vv-as="$t('latitude')"
                    v-validate="'required'"
                    name="latitude"
                    v-model="input.latitude"
                    type="number"
                  />
                  <span class="text-error" v-if="errors.has('latitude')">{{
                    errors.first('latitude')
                  }}</span>
                </div>
              </v-flex>
              <v-flex pa-1 xs6>
                <div class="form-control" :class="{ 'has-error': errors.has('longitude') }">
                  <label>longitude</label>
                  <input
                    :data-vv-as="$t('longitude')"
                    v-validate="'required'"
                    name="longitude"
                    v-model="input.longitude"
                    type="number"
                  />
                  <span class="text-error" v-if="errors.has('longitude')">{{
                    errors.first('longitude')
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
            <div class="form-control has-error">
              <label>รูปโครงการ</label>
              <uploadfile
                name="picture"
                v-model="input.project_pic"
                @onUploaded="onUploaded"
              ></uploadfile>
              <span class="text-error" v-if="nopicture">กรุณาอัพโหลดรูปภาพ</span>
            </div>
            <div style="text-align: center; margin-top: 5px">
              <v-btn @click="closeDialog('create')" outline color="grey">ยกเลิก</v-btn>
              <v-btn
                @click="createProject"
                :loading="createloading"
                :disabled="createloading"
                depressed
                color="primary"
                >บันทึก</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card
        v-for="(item, k) in data"
        :key="item.id"
        style="border-radius: 15px; margin-bottom: 15px"
      >
        <v-layout style="height: 290px; overflow: hidden">
          <v-flex xs5>
            <v-img
              height="100%"
              width="100%"
              :src="item.project_pic ? item.project_pic : imgplaceholder"
            />
          </v-flex>
          <v-flex xs7 style="padding: 18px; padding-top: 25px">
            <div style="position: absolute; right: 10px; top: 10px">
              <v-icon @click="editProject(item)" style="cursor: pointer">edit</v-icon>
              <v-icon @click="deleteProject(item.id, k)" style="cursor: pointer">delete</v-icon>
            </div>
            <div style="margin-bottom: 6px">
              <label>ชื่อโครงการ</label>
              <div class="header font-weight-bold">{{ item.name }}</div>
            </div>
            <div style="margin-bottom: 6px">
              <label>รายละเอียดโครงการ</label>
              <div class="header font-weight-bold">{{ item.description }}</div>
            </div>
            <div style="margin-bottom: 6px">
              <label>เบอร์โทรศัพท์</label>
              <div class="header font-weight-bold">{{ item.phoneno ? item.phoneno : '-' }}</div>
            </div>
            <div>
              <label>ระยะทางเป้าหมาย(km)</label>
              <div class="header font-weight-bold">{{ item.goal ? item.goal : '-' }}</div>
            </div>
            <div>
              <label>วันที่สิ้นสุดโครงการ</label>
              <div class="header font-weight-bold">
                {{ item.endproject | DateFormat('DD/MM/YYYY') }}
              </div>
            </div>

            <span
              style="
                position: absolute;
                bottom: 8px;
                right: 15px;
                font-weight: 600;
                font-size: 20px;
                text-align: right;
              "
            >
              <label>ยอดบริจาค</label>
              <div :style="`color: ${$vuetify.theme.primary}`">{{ item.donation_amount }}</div>
            </span>
          </v-flex>
        </v-layout>
      </v-card>
      <v-dialog persistent v-model="dialog.edit" max-width="590">
        <div v-if="dialog.edit">
          <form-edit @closedialog="closeDialog" @cancel="cancelEdit" :data="edit.data"></form-edit>
        </div>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import formEdit from './formEdit.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import moment from 'moment'

export default {
  data() {
    return {
      data: [],
      imgplaceholder:
        'https://glowvarietyshow.com/wp-content/uploads/2017/03/placeholder-image.jpg',
      dialog: {
        create: false,
        edit: false
      },
      edit: {
        data: ''
      },
      createloading: false,
      input: {
        projectname: '',
        description: '',
        project_pic: null,
        address: '',
        phoneno: '',
        latitude: '',
        longitude: '',
        goal: '',
        endproject: ''
      },
      showEndproject: false,
      nopicture: false,
      cache: ''
    }
  },
  components: {
    uploadfile,
    formEdit,
    AutoresizeTextarea
  },
  mounted() {
    this.getProject()
  },
  computed: {
    formattedEndprojectDate() {
      if (this.input.endproject) {
        return moment(this.input.endproject).format('DD-MM-YYYY')
      }
    }
  },
  methods: {
    editProject(data) {
      this.cache = JSON.stringify(this.data)
      this.edit.data = data
      this.dialog.edit = true
    },
    cancelEdit() {
      this.data = JSON.parse(this.cache)
    },
    createProject() {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        if (!this.input.project_pic) return (this.nopicture = true)
        this.createloading = true
        api.postrunbetterdonationproject(this.input, function (error, response) {
          if (error) return console.error(error)
          if (response.data) {
            vm.data.push(response.data[0])
            vm.createloading = false
            vm.dialog.create = false
          }
        })
      })
    },
    closeDialog(val) {
      this.dialog[val] = false
    },
    onUploaded(url) {},
    getProject() {
      let vm = this
      api.getrunbetterdonationproject(null, function (error, response) {
        if (error) return console.error(error)
        if (response.data) {
          vm.data = response.data
        }
      })
    },
    deleteProject(id, k) {
      let vm = this
      this.$swal
        .fire({
          text: 'คุณต้องการลบโครงการนี้หรือไม่?',
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        })
        .then((result) => {
          if (result.value) {
            api.deleterunbetterdonationproject({ id: id }, function (error, response) {
              if (error) console.error(error)
              let index = vm.data.findIndex((el) => el.id == id)
              vm.data.splice(index, 1)
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runbetter/main.vue